import type { ResourcesConfig } from '@aws-amplify/core';

import config from './config';

const awsConfig: ResourcesConfig = {
    Auth: {
        Cognito: {
            userPoolId: config.COGNITO_USER_POOL_ID,
            userPoolClientId: config.COGNITO_APP_CLIENT_ID,
            loginWith: {
                oauth: {
                    domain: config.COGNITO_DOMAIN,
                    scopes: ['email', 'openid'],
                    redirectSignIn: [config.COGNITO_REDIRECT_SIGN_IN ?? `${window.location.origin}/`],
                    redirectSignOut: [config.COGNITO_REDIRECT_SIGN_OUT ?? `${window.location.origin}/`],
                    responseType: 'code',
                },
            },
        },
    },
};

export { awsConfig };
